import { connect } from 'react-redux';
import { Forms } from '../..';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Secciones } from '../index.service';
import styles from './index.module.scss';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionSeguimiento({ storage, t,
  data,
  onUpdateFields,
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);
  
  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Seguimiento}`)}</div>
    
    <div className='p-grid'>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.tipogestion")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.tipogestion}
          options={() => TiposGestiones.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.tipogestion', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.proximagestion")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.proximagestion}
          options={() => ProximasGestiones.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.proximagestion', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.cotizacioninfo.proximagestionfecha")}
          className={styles["fix-form-component"]}
          value={new Date(data?.cotizacion?.proximagestionfecha as any)} 
          onChange={(v,e) => onUpdateField('cotizacion.proximagestionfecha', v)}
        />
      </div>

      
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.medioingreso")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.medioingreso}
          options={() => MediosIngresos.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.medioingreso', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.tiposervicio")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.tiposervicio}
          options={() => TiposServicios.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.tiposervicio', v)}
        />
      </div>


      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.origenmarca")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.origenmarca}
          options={() => OrigenesMarca.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.origenmarca', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Input
          title={t("Seccion.Field.cotizacioninfo.origenservicio")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.origenservicio}
          onChange={(v,e) => onUpdateField('cotizacion.origenservicio', v)}
        />
      </div>
      <div className='p-col-12 p-lg-4 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacioninfo.origencanalventa")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.origencanalventa}
          options={() => OrigenesCanalVenta.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.origencanalventa', v)}
        />
      </div>

      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.InputNumber
          title={t("Seccion.Field.cotizacioninfo.totalcotizacion")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.totalcotizacion}
          onChange={(v,e) => onUpdateField('cotizacion.totalcotizacion', v)}
        />
      </div>

      
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.Dropdown
          title={t("Seccion.Field.cotizacion.motivoCancelacion")}
          className={styles["fix-form-component"]}
          value={data?.cotizacion?.motivocancelacion}
          options={() => MotivosCancelacion.map(p => ({ id: p.id, name: t(p.nombre) }))} optionLabel='name' optionValue='id'
          onChange={(v,e) => onUpdateField('cotizacion.motivocancelacion', v)}
        />
      </div>
    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionSeguimiento);


export const TiposGestiones = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  //{ id: "CONTACTO 1", nombre: "#CONTACTO 1" },  // eliminado en CNET-93
  //{ id: "CONTACTO 2", nombre: "#CONTACTO 2" },  // eliminado en CNET-93
  //{ id: "CONTACTO 3", nombre: "#CONTACTO 3" },  // eliminado en CNET-93
  //{ id: "CONTACTO 4", nombre: "#CONTACTO 4" },  // eliminado en CNET-93
  //{ id: "CONTACTO 5", nombre: "#CONTACTO 5" },  // eliminado en CNET-93
  //{ id: "CONTACTO +6", nombre: "#CONTACTO +6" },  // eliminado en CNET-93
  { id: "#NOCONTESTA", nombre: "#No contesta" },
  { id: "#COTIZADO", nombre: "#Cotizado, en seguimiento" },
  { id: "#BARRIDO 1", nombre: "#Barrido mail 1" },
  { id: "#BARRIDO 2", nombre: "#Barrido mail 2" },
  { id: "#BARRIDO 3", nombre: "#Barrido mail 3" },
  { id: "#DATO BASURA", nombre: "#Dato Basura" },
  { id: "#VENTA", nombre: "#Venta" },
  //{ id: "BARRIDO 4", nombre: "#BARRIDO 4" },  // eliminado en CNET-93
  //{ id: "BARRIDO 5", nombre: "#BARRIDO 5" },  // eliminado en CNET-93
  //{ id: "BARRIDO +6", nombre: "#BARRIDO +6" },  // eliminado en CNET-93
  //{ id: "REUNION", nombre: "#REUNION" },  // eliminado en CNET-93
];

export const ProximasGestiones = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  //{ id: "COTIZAR", nombre: "#COTIZAR" },   // eliminado en CNET-93
  { id: "#INTENTO", nombre: "#Intento de contacto" },
  { id: "#RE COTIZAR", nombre: "#Recotizar" },
  { id: "#DESCUENTO", nombre: "#Descuento adicional" },
  { id: "#DESCUENTO-5", nombre: "#5% descuento" },
  { id: "#DESCUENTO-10", nombre: "#10% descuento" },
  // { id: "LLAMADA/CONTACTO", nombre: "#LLAMADA/CONTACTO" },   // eliminado en CNET-93
  // { id: "BARRIDO", nombre: "#BARRIDO" },  // eliminado en CNET-93
  // { id: "OTROS", nombre: "#OTROS" },  // eliminado en CNET-93
]

const MediosIngresos = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  { id: "#WHATSAPP", nombre: "#WhatsApp" },
  { id: "#TELEFONO IN", nombre: "#Llamada IN" },
  { id: "#TELEFONO OUT", nombre: "#Llamada OUT" },
  { id: "#REFERIDO", nombre: "#Referido" },
  { id: "##REFERIDO-GERENCIA", nombre: "#Referido Gerencia" },
  { id: "##EMAIL", nombre: "#Mail" },
  { id: "#EMAILPROMO", nombre: "#Mail promo" },
  { id: "#NEWSLETTER", nombre: "#Newsletter" },
  { id: "#FACEBOOK", nombre: "#Facebook" },
  { id: "#INSTAGRAM", nombre: "#Instagram" },
  { id: "#LANDBOT", nombre: "#Landbot" },  // agregado por pedido de charly 29/6/2024
  // { id: "CHAT", nombre: "#CHAT" }, // eliminado en CNET-93
  // { id: "TELEGRAM", nombre: "#TELEGRAM" }, // eliminado en CNET-93
  // { id: "WEB", nombre: "#WEB" }, // eliminado en CNET-93
  // { id: "SKYPE", nombre: "#SKYPE" }, // eliminado en CNET-93
]

const TiposServicios = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  { id: "#VIAJERO", nombre: "#Viajero" },
  // { id: "MULTISERVICIOS", nombre: "#MULTISERVICIOS" }, // eliminado en CNET-93
  { id: "#CORPORATIVO", nombre: "#Corporativo" },
]


const OrigenesMarca = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  { id: "#TUSEGURODEVIAJE", nombre: "#TSV" },
  { id: "#ASSISTO", nombre: "#ASS" },
  { id: "#AVI", nombre: "#AVI" },
  // { id: "CNET", nombre: "#CNET" }, // eliminado en CNET-93
]

const OrigenesCanalVenta = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  { id: "#CALL", nombre: "#CALL CENTER" },
  //{ id: "CALL OUT", nombre: "#CALL OUT" }, // eliminado en CNET-93
  { id: "#ON LINE", nombre: "#ONLINE" },
  { id: "#CANAL", nombre: "#CANAL" },
  // { id: "CANAL AGV", nombre: "#CANAL AGV" }, // eliminado en CNET-93
  // { id: "CANAL GSA", nombre: "#CANAL GSA" }, // eliminado en CNET-93
  // { id: "CANAL PAS", nombre: "#CANAL PAS" }, // eliminado en CNET-93
  // { id: "MARCA BLANCA", nombre: "#MARCA BLANCA" }, // eliminado en CNET-93
  // { id: "OTROS", nombre: "#OTROS" }, // eliminado en CNET-93
]

const MotivosCancelacion = [
  { id: undefined, nombre: "@Id#SinSeleccionar" },
  { id:"#Compró en otro lado", nombre:"#Compró en otro lado" },
  { id:"#Compró con otro asesor", nombre:"#Compró con otro asesor" },
  { id:"#Datos erróneos", nombre:"#Datos erróneos" },
  { id:"#Le pareció caro", nombre:"#Le pareció caro" },
  { id:"#Lo tiene por la tarjeta de crédito", nombre:"#Lo tiene por la tarjeta de crédito" },
  { id:"#Necesita cuotas sin interés", nombre:"#Necesita cuotas sin interés" },
  { id:"#No contesta", nombre:"#No contesta" },
  { id:"#No encontró el producto", nombre:"#No encontró el producto" },
  { id:"#Quiere pagar en efectivo", nombre:"#Quiere pagar en efectivo" },
  { id:"#Se canceló el viaje", nombre:"#Se canceló el viaje" },
  { id:"#Vendido en otra OP", nombre:"#Vendido en otra OP" },
  { id:"#Inició vigencia", nombre:"#Inició vigencia" },
  { id:"#Gestion de otro asesor", nombre:"#Gestion de otro asesor" },
];